import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../../common/types';
import { PresaveWidgetFormContainer } from './PresaveWidgetFormContainer';

interface PresaveWidgetCatalogOnlyViewProps {
  accountId: number;
  smartLinkId: number;
  trackTitle: string;
  isLoading: boolean;
  onDelete: () => void;
}

/**
 * A "Catalog links" block of a song with no pre-save campaign. It has nothing to edit: the page
 * shows the song's streaming links from the catalog, and they change when the catalog changes.
 * The block can still be deleted.
 */
const PresaveWidgetCatalogOnlyViewComponent: React.FC<PresaveWidgetCatalogOnlyViewProps> = ({
  accountId,
  smartLinkId,
  trackTitle,
  isLoading,
  onDelete,
}) => {
  const intl = useIntl();

  return (
    <PresaveWidgetFormContainer
      accountId={accountId}
      smartLinkId={smartLinkId}
      isLoading={isLoading}
      onDelete={onDelete}
    >
      <div className="text-muted">
        {intl.formatMessage(
          {
            id: 'app.sml.presave.block.catalog_only_note',
            defaultMessage:
              'This block shows the streaming links of {title} from your catalog. A link that the catalog finds later shows here too.',
          },
          { title: trackTitle }
        )}
      </div>
    </PresaveWidgetFormContainer>
  );
};

export const PresaveWidgetCatalogOnlyView = TypedMemo(PresaveWidgetCatalogOnlyViewComponent);
